// Service layer for the patient mood check-in.
//
// Backend: GET  /api/secure/me/mood/options     — picker config
//          GET  /api/secure/me/mood/today       — today's check-in (or null)
//          GET  /api/secure/me/mood/today-card  — full Today-card payload
//          GET  /api/secure/me/mood/recent      — last 7 days, gap-filled
//          POST /api/secure/me/mood/check-in    — record (upserts per IST day)
//
// The Today aggregate (/me/today) already embeds the full mood-card payload
// in the `moodCheckIn` field, so the only call most flows need is the POST
// here — this service exists for direct-fetch refreshes (e.g. after editing
// today's mood without refetching the whole dashboard).

import { shouldUseMocks } from './mockApi'
import * as mock from './mockApi/moodApi'
import { patientGet, patientPost } from './patientApi'

const BASE = '/api/secure/me/mood'

const ctx = (profile) => ({ requirePatientContext: true, profileId: profile?.id })

export async function getOptions(profile) {
  if (shouldUseMocks()) return mock.getOptions()
  const res = await patientGet(`${BASE}/options`, ctx(profile))
  return res?.data || { options: [], factors: [] }
}

export async function getTodaysMood(profile) {
  if (shouldUseMocks()) return mock.getTodaysMood(profile)
  const res = await patientGet(`${BASE}/today`, ctx(profile))
  return res?.data || null
}

export async function getTodayCard(profile) {
  if (shouldUseMocks()) return mock.getTodayCard(profile)
  const res = await patientGet(`${BASE}/today-card`, ctx(profile))
  return res?.data || null
}

export async function getRecent(profile) {
  if (shouldUseMocks()) return mock.getRecent(profile)
  const res = await patientGet(`${BASE}/recent`, ctx(profile))
  return res?.data || []
}

/**
 * Record (or replace) today's mood check-in. Server upserts per IST day —
 * tapping a different mood later in the day overwrites rather than stacks.
 *
 * payload: { moodCode: 'GREAT'|'GOOD'|'OK'|'OFF'|'LOW',
 *            note?: string, factors?: string[] }
 */
export async function recordCheckIn(profile, payload) {
  if (shouldUseMocks()) return mock.recordCheckIn(profile, payload)
  const res = await patientPost(`${BASE}/check-in`, payload, ctx(profile))
  return res?.data
}
